export default __webpack_public_path__ + "assets/f3263df56c33fc79836a2c25c98a8196.png";